import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { BookingService } from '@shared/services/booking.service';

@Component({
  selector: 'app-toolbar-item-activities',
  templateUrl: './toolbar-item-activities.component.html',
  styleUrls: ['./toolbar-item-activities.component.scss']
})
export class ToolbarItemActivitiesComponent implements OnInit {

  @Input() item!: IToolbarItem;
  @Output() selectedChange = new EventEmitter<boolean>();
  
  public isActive: boolean = false;

  constructor(private bookingService: BookingService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.bookingService.activeIcon$.subscribe(activeIcon => {
      this.isActive = this.item.icon === activeIcon;
      this.cdr.detectChanges();
    });
  }

  getActivity(msg: string | null | undefined): void {
    if (msg) {
      this.bookingService.updateSelectedActivity([msg]);
      this.bookingService.updateActiveIcon(this.item.icon);
    }
  }

  toggleActive() {
    this.isActive = !this.isActive;
    if (this.isActive) {
      this.bookingService.updateActiveIcon(this.item.icon);
    } else {
      this.bookingService.updateActiveIcon(null);
    }
  }
  
}
